import React, { useEffect, useState, divider } from "react";
import { useDispatch, useSelector } from "react-redux";
import { borrarTarea } from "../../features/registroTareasSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListadoArchivos from "../Archivos/ListadoArchivosPedidoComunicacion";
import SubirArchivoComunicacion from "../Archivos/SubirArchivoComunicacion";

// Subcomponentes
import Disenio from "../Comunicacion/Tareas/Disenio";
import Evento from "../Comunicacion/Tareas/Evento";
import Impresion from "../Comunicacion/Tareas/Impresion";
import RevisionTexto from "../Comunicacion/Tareas/RevisionTexto";
import SolicitudDePresupuesto from "../Comunicacion/Tareas/SolicitudDePresupuesto";
import PublicacionEnRedes from "../Comunicacion/Tareas/PublicacionEnRedes";

import { useNavigate } from "react-router-dom";

// Material UI y Lucide Icons
import { 
  Box, Typography, Card, TextField, Grid, Button, IconButton, 
  MenuItem, Dialog, DialogTitle, DialogContent, Stack, Paper, Chip, Divider 
} from "@mui/material";
import { 
  X, Send, Trash2, FileText, Calendar, Layout, AlertCircle, CheckCircle2 
} from "lucide-react";

const PALETTE = { 
  ice: "#C2EDF0", 
  aqua: "#00C0CA", 
  teal: "#008B9C", 
  dark: "#22404D", 
  slate: "#94A3B8",
  red: "#F65F4E",
  pearl: "#EEF3F4"
};

const AgregarPedido = () => {
  // ==========================================
  // ZONA INTOCABLE: LÓGICA Y ESTADOS EXACTOS
  // ==========================================
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [valorDelSelect, setvalorDelSelect] = useState("");
  const [nombre, setNombre] = useState("");
  const [fecha, setFecha] = useState("");
  const [pedidoActualId, setPedidoActualId] = useState();
  const items = useSelector((state) => state.tareas.Tareas);
  const [programaId, setProgramaID] = useState();
  const dispatch = useDispatch();
  const [aux, setAux] = useState(0);
  const [error, setError] = useState("");
  const cambioSelect = (event) => {
    setvalorDelSelect(event.target.value);
  };
  const [mostrarModal, setMostrarModal] = useState(false);
  const [cargando, setCargando] = useState(false);

  const navigate = useNavigate();

  const eliminarTarea = (tarea) => {
    dispatch(borrarTarea(tarea));
  };

  const [programas, setProgramas] = useState([]);

  const handleSelectChange = (e) => {
    setProgramaID(e.target.value);
  };

  useEffect(() => {
    const fetchProgramasPorUsuario = async () => {
      try {
        const response = await fetch( `${apiUrl}/Usuarios/obtenerProgramasDeUsuario?mail=${localStorage.getItem("email")}`,{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apiKey': localStorage.getItem("apiKey")  
            }}
        );
        if (response.ok) {
          const data = await response.json();
          setProgramas(data);
        }
      } catch (error) {
        console.error("Error fetching programas:", error);
        manejarErrores(error.status)
      }
    };
    fetchProgramasPorUsuario();
  }, []);

  const manejarErrores = (estatus) => {
    switch (estatus) {
      case 400:
        setError("Solicitud incorrecta. Verifica los datos enviados.");
        toast.error("Solicitud incorrecta. Verifica los datos enviados.", { position: "bottom-center", autoClose: 3000 });
        break;
      case 401:
        setError("No autorizado. Por favor inicia sesión.");
        toast.error("No autorizado. Por favor inicia sesión.", { position: "bottom-center", autoClose: 3000 });
        localStorage.clear();
        navigate("/");
        break;
      case 403:
        setError("Acceso denegado. No tienes permiso para acceder a este recurso.");
        toast.error("Acceso denegado. No tienes permiso para acceder a este recurso.", { position: "bottom-center", autoClose: 3000 });
        navigate("/dashboardCoordinador");
        break;
      case 500:
        setError("Error interno del servidor. Inténtalo de nuevo más tarde.");
        toast.error("Error interno del servidor. Inténtalo de nuevo más tarde.", { position: "bottom-center", autoClose: 3000 });
        localStorage.clear();
        navigate("/");
        break;
      default:
        setError("Ocurrió un error inesperado.");
        toast.error("Ocurrió un error inesperado.", { position: "bottom-center", autoClose: 3000 });
        break;
    }
  };

  const agregarPedido = async (e) => {
    e.preventDefault();
    setCargando(true)
    e.target.disabled = true;
    
    setTimeout(() => { e.target.disabled = false; }, 3000);

    if (validar()) {
      setCargando(false);
      return;
    }
    try {
      const pedido = {
        id: 0,
        estado: "Pendiente",
        programaID: programaId,
        fechaLimite: fecha,
        nombre: nombre,
        programa: null,
        tareas: items,
        email: localStorage.getItem("email"),
      };

      let respuesta = await fetch(`${apiUrl}/Pedido`, {
        method: "POST",
        headers: {
         'Content-Type': 'application/json',
         'apiKey': localStorage.getItem("apiKey")
        },
        body: JSON.stringify(pedido),
      });

      if (respuesta.ok) {
        const data = await respuesta.json();
        toast.success("Pedido agregado correctamente", { position: "bottom-center", autoClose: 3000 });
        setPedidoActualId(data.id);
        setAux(aux + 1);
        setMostrarModal(true);
      } else {
        manejarErrores(respuesta.status);
      }
    } catch (error) {}
    finally {
      setCargando(false);  
    }
  };

  const redirigir = () => {
    navigate("/listaPedidosPorPrograma/"+programaId);
  }

  const validar = () => {
    const fechaFormulario = new Date(fecha);
    const fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0);
    fechaFormulario.setHours(0, 0, 0, 0);

    let mensaje = "";
    if (fechaFormulario < fechaActual) {
      mensaje = "La fecha límite debe ser una fecha futura.";
    } else if (items.length === 0) {
      mensaje = "No ingreso tareas en el pedido.";
    }

    if (mensaje !== "") {
      toast.error(mensaje, { position: "bottom-center", autoClose: 3000 });
      return true;
    } else {
      return false;
    }
  };

  const actualizarListado = () => {
    setAux(aux + 1);
  };
  // ==========================================
  // FIN DE LA LÓGICA INTOCABLE
  // ==========================================

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#F8FAFB", pt: { xs: 10, md: 12 }, pb: 6, px: { xs: 2, md: 4 } }}>
      <Box maxWidth="1200px" mx="auto">
        
        <Box mb={4} textAlign="center">
          <Typography variant="h4" sx={{ fontWeight: 900, color: PALETTE.dark }}>
            Pedido a Comunicación
          </Typography>
          <Typography variant="body1" sx={{ color: PALETTE.slate, fontWeight: 600 }}>
            Configura y añade tareas a tu solicitud
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {/* COLUMNA IZQUIERDA: FORMULARIO PRINCIPAL */}
          <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: '32px', border: '1px solid #eee', bgcolor: 'white' }}>
              <form onSubmit={agregarPedido}>
                
                {/* Nombre de la actividad */}
                <Box mb={3}>
                  <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>NOMBRE DEL PEDIDO</Typography>
                  <TextField 
                    fullWidth 
                    name="nombre" 
                    value={nombre} 
                    onChange={(e) => setNombre(e.target.value)} 
                    placeholder="Ej: Lanzamiento de campaña" 
                    required 
                    sx={{ mt: 1, "& .MuiOutlinedInput-root": { borderRadius: '16px', bgcolor: '#FAFAFA' } }} 
                  />
                </Box>

                {/* Fecha Límite */}
                <Box mb={3}>
                  <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>FECHA LÍMITE</Typography>
                  <TextField 
                    fullWidth 
                    type="date" 
                    name="fechaLimite" 
                    inputProps={{ min: new Date().toISOString().split('T')[0] }}
                    value={fecha} 
                    onChange={(e) => setFecha(e.target.value)} 
                    required 
                    sx={{ mt: 1, "& .MuiOutlinedInput-root": { borderRadius: '16px', bgcolor: '#FAFAFA' } }} 
                  />
                </Box>

                {/* Programa */}
                <Box mb={3}>
                  {programas.length === 0 ? (
                    <Box sx={{ p: 2, bgcolor: '#FFF4E5', color: '#663C00', borderRadius: '16px', display: 'flex', alignItems: 'center', gap: 1 }}>
                      <AlertCircle size={20} />
                      <Typography variant="body2" fontWeight={700}>No tienes programas asignados.</Typography>
                    </Box>
                  ) : (
                    <>
                      <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>PROGRAMA</Typography>
                      <TextField 
                        select 
                        fullWidth 
                        name="idPrograma" 
                        value={programaId || ""} 
                        onChange={handleSelectChange} 
                        required 
                        sx={{ mt: 1, "& .MuiOutlinedInput-root": { borderRadius: '16px', bgcolor: '#FAFAFA' } }}
                      >
                        <MenuItem value=""><em>Selecciona un programa</em></MenuItem>
                        {programas.map((programa) => (
                          <MenuItem key={programa.id} value={programa.id}>{programa.nombre}</MenuItem>
                        ))}
                      </TextField>
                    </>
                  )}
                </Box>

                <Box mt={4} mb={2}>
                   <Divider sx={{ borderColor: PALETTE.pearl }} />
                </Box>

                {/* Selección de Tipo de Tarea */}
                <Box mb={3}>
                  <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.teal }}>AÑADIR NUEVA TAREA AL PEDIDO</Typography>
                  <TextField 
                    select 
                    fullWidth 
                    value={valorDelSelect} 
                    onChange={cambioSelect} 
                    sx={{ mt: 1, "& .MuiOutlinedInput-root": { borderRadius: '16px', bgcolor: PALETTE.ice, color: PALETTE.dark, fontWeight: 700 } }}
                  >
                    <MenuItem value=""><em>Seleccione el tipo de tarea...</em></MenuItem>
                    <MenuItem value="Disenio">Diseño</MenuItem>
                    <MenuItem value="Evento">Evento</MenuItem>
                    <MenuItem value="Impresion">Impresión</MenuItem>
                    <MenuItem value="PublicacionEnRedes">Publicación en redes</MenuItem>
                    <MenuItem value="RevisionTexto">Revisión de texto</MenuItem>
                    <MenuItem value="SolicitudDePresupuesto">Solicitud de presupuesto</MenuItem>
                  </TextField>
                </Box>

                {/* Renderizado Condicional del Subcomponente */}
                <Box mb={4}>
                  {valorDelSelect === "Disenio" && <Disenio idPedido={0} />}
                  {valorDelSelect === "Evento" && <Evento idPedido={0} />}
                  {valorDelSelect === "Impresion" && <Impresion idPedido={0} />}
                  {valorDelSelect === "PublicacionEnRedes" && <PublicacionEnRedes idPedido={0}/>}
                  {valorDelSelect === "RevisionTexto" && <RevisionTexto idPedido={0} />}
                  {valorDelSelect === "SolicitudDePresupuesto" && <SolicitudDePresupuesto idPedido={0} />}
                </Box>

                <Button 
                  type="submit" 
                  fullWidth 
                  disabled={cargando} 
                  variant="contained" 
                  startIcon={<Send size={20} />}
                  sx={{ borderRadius: '16px', py: 1.8, fontWeight: 800, bgcolor: PALETTE.teal, fontSize: '1rem', '&:hover': { bgcolor: PALETTE.dark } }}
                >
                  {cargando ? "Procesando..." : "Finalizar y Crear Pedido"}
                </Button>
              </form>
            </Card>
          </Grid>

          {/* COLUMNA DERECHA: LISTA DE TAREAS */}
          <Grid item xs={12} md={6}>
             <Typography variant="subtitle1" sx={{ fontWeight: 900, color: PALETTE.dark, mb: 2, ml: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Layout size={20} color={PALETTE.teal} /> Resumen de Tareas Agregadas
            </Typography>
            
            <Card elevation={0} sx={{ p: 3, borderRadius: '32px', border: '1px solid #eee', bgcolor: 'white', minHeight: '100%' }}>
              {items.length !== 0 ? (
                <Stack spacing={2}>
                  {items.map((tarea, index) => (
                    <Paper 
                      key={index} 
                      elevation={0} 
                      sx={{ p: 2, borderRadius: '16px', bgcolor: PALETTE.pearl, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', border: `1px solid ${PALETTE.ice}` }}
                    >
                      <Box>
                        {Object.keys(tarea).map((key) => (
                          key !== "id" && (
                            <Typography key={key} variant="body2" sx={{ color: PALETTE.dark, mb: 0.5 }}>
                              <strong style={{ color: PALETTE.teal }}>
                                {key.charAt(0).toUpperCase() + key.slice(1)}:
                              </strong>{" "}
                              {typeof tarea[key] === "boolean" ? (tarea[key] ? "Sí" : "No") : tarea[key]}
                            </Typography>
                          )
                        ))}
                      </Box>
                      <IconButton 
                        onClick={() => eliminarTarea(tarea)} 
                        sx={{ color: PALETTE.red, bgcolor: 'white', '&:hover': { bgcolor: '#FDECEA' } }}
                      >
                        <Trash2 size={18} />
                      </IconButton>
                    </Paper>
                  ))}
                </Stack>
              ) : (
                <Box sx={{ p: 4, textAlign: 'center', bgcolor: '#FAFAFA', borderRadius: '16px', border: '1px dashed #CCC' }}>
                  <FileText size={40} color={PALETTE.slate} style={{ marginBottom: '16px', opacity: 0.5 }} />
                  <Typography variant="body1" sx={{ color: PALETTE.slate, fontWeight: 600 }}>
                    Aún no has agregado ninguna tarea al pedido.
                  </Typography>
                  <Typography variant="body2" sx={{ color: PALETTE.slate }}>
                    Usa el selector de la izquierda para comenzar.
                  </Typography>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* MODAL / DIALOG REEMPLAZADO */}
      <Dialog 
        open={mostrarModal} 
        onClose={() => redirigir()} 
        maxWidth="md" 
        fullWidth
        PaperProps={{ sx: { borderRadius: '32px', p: 2 } }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 900, color: PALETTE.dark }}>Archivos Necesarios</Typography>
            <Typography variant="body2" sx={{ color: PALETTE.slate, fontWeight: 600 }}>Sube los adjuntos para la realización del pedido</Typography>
          </Box>
          <IconButton onClick={() => redirigir()} sx={{ bgcolor: PALETTE.ice }}>
            <X size={20} color={PALETTE.teal} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <SubirArchivoComunicacion
              pedidoId={pedidoActualId}
              tareaId={0}
              actualizar={actualizarListado}
            />
            <Box mt={4}>
              <ListadoArchivos pedidoId={pedidoActualId} actualizar={aux} />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AgregarPedido;